import React, { JSX, useState } from 'react';
import ViewAllPanel from '../ViewAllPanel';
import {
  AddFilterType,
  FacetValue,
  RemoveFilterType,
} from 'components/types/FilterTypes';

type StandardFilterProps = {
  addFilter: AddFilterType;
  filters: Array<FacetValue>;
  filterCategory: string;
  inputType?: string;
  placeholder: string;
  removeFilter: RemoveFilterType;
  selectedData: Array<string>;
  selectedDataSecondary?: Array<string>;
  title: string;
  noCount?: boolean;
};

const StandardFilter = (props: StandardFilterProps): JSX.Element => {
  const [viewAllOpen, setViewAllOpen] = useState(false);

  const toggleViewAll = () => {
    if (viewAllOpen) {
      setViewAllOpen(false);
    } else {
      setViewAllOpen(true);
    }
  };

  const {
    addFilter,
    filters,
    filterCategory,
    placeholder,
    removeFilter,
    selectedData,
    title,
    inputType = 'checkbox',
    noCount,
  } = props;

  return (
    <>
      <ViewAllPanel
        addFilter={addFilter}
        filters={filters}
        filterCategory={filterCategory}
        inputType={inputType}
        isOpen={viewAllOpen}
        placeholder={placeholder}
        removeFilter={removeFilter}
        selectedData={selectedData}
        title={title}
        toggleViewAll={toggleViewAll}
        noCount={noCount}
      />
    </>
  );
};

export default StandardFilter;
